// @flow
import type { Country } from '../../entities';

export type AddressIntl = {
  title: string;
  address: {
    label: string;
    value: string;
  };
  reference: {
    label: string;
    value: string;
  };
  businessHours: {
    label: string;
    value: string;
  };
  phone: {
    label: string;
    value: string;
  };
};

export function getQempoAddress(country: Country): AddressIntl {
  let base = {
    title: '',
    address: {
      label: 'qempo.address.label',
      value: '',
    },
    reference: {
      label: 'qempo.reference.label',
      value: '',
    },
    businessHours: {
      label: 'qempo.businessHours.label',
      value: '',
    },
    phone: {
      label: 'qempo.phone.label',
      value: '',
    }
  };

  switch (country) {
    case 'PE':
      base.title = 'qempo.address.PE.title';
      base.address.value = 'qempo.address.PE.value';
      base.reference.value = 'qempo.reference.PE.value';
      base.businessHours.value = 'qempo.businessHours.PE.value';
      base.phone.value = 'qempo.phone.PE.value';
      break;
    case 'CO':
      base.title = 'qempo.address.CO.title';
      base.address.value = 'qempo.address.CO.value';
      base.reference.value = 'qempo.reference.CO.value';
      base.businessHours.value = 'qempo.businessHours.CO.value';
      base.phone.value = 'qempo.phone.CO.value';
      break;
  }
  return base;
}



// WEBPACK FOOTER //
// ./src/utils/qempoAdresses/index.js